(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dag-frames-of-motion-master"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-fom-master]').forEach(function (root) {
    if (root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    var records = Array.from(root.querySelectorAll('[data-fom-variant]'));
    if (!records.length) return;

    var input = root.querySelector('[data-fom-variant-input]');
    var acquire = root.querySelector('[data-fom-acquire]');
    var priceNode = root.querySelector('[data-fom-price]');
    var mobilePrice = root.querySelector('[data-fom-mobile-price]');
    var enquiryPresentation = root.querySelector('[data-fom-enquiry-presentation]');
    var selectedSize = root.querySelector('[data-fom-size].is-selected')?.dataset.fomSize || records[0].dataset.size;
    var selectedFrame = root.querySelector('[data-fom-frame].is-selected')?.dataset.fomFrame || records[0].dataset.frame;

    function findVariant(size, frame) {
      return records.find(function (item) {
        return item.dataset.size === size && item.dataset.frame === frame && item.dataset.available === 'true';
      }) || records.find(function (item) {
        return item.dataset.size === size && item.dataset.frame === frame;
      }) || null;
    }

    function resolveSelection(updateUrl) {
      var record = findVariant(selectedSize, selectedFrame);
      if (!record || record.dataset.available !== 'true') {
        var fallback = records.find(function (item) {
          return item.dataset.size === selectedSize && item.dataset.available === 'true';
        }) || records.find(function (item) {
          return item.dataset.available === 'true';
        }) || records[0];
        if (fallback) {
          record = fallback;
          selectedSize = fallback.dataset.size;
          selectedFrame = fallback.dataset.frame;
        }
      }
      if (!record) return;

      input.value = record.dataset.id;
      if (priceNode) priceNode.textContent = record.dataset.price;
      if (mobilePrice) mobilePrice.textContent = record.dataset.price;
      if (enquiryPresentation) enquiryPresentation.value = record.dataset.title;

      root.querySelectorAll('[data-fom-size]').forEach(function (button) {
        var active = button.dataset.fomSize === selectedSize;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
        var matching = findVariant(button.dataset.fomSize, selectedFrame) || records.find(function (item) {
          return item.dataset.size === button.dataset.fomSize;
        });
        var node = button.querySelector('[data-fom-size-price]');
        if (node && matching) node.textContent = matching.dataset.priceShort;
      });

      root.querySelectorAll('[data-fom-frame]').forEach(function (button) {
        var active = button.dataset.fomFrame === selectedFrame;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
      });

      if (acquire) {
        var available = record.dataset.available === 'true';
        acquire.disabled = !available;
        var label = acquire.querySelector('span');
        var word = acquire.dataset.label || 'Acquire';
        if (label) label.innerHTML = available ? word + ' — <strong>' + record.dataset.price + '</strong>' : 'Unavailable';
      }

      if (updateUrl) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', record.dataset.id);
        window.history.replaceState(window.history.state, '', url);
      }
    }

    root.querySelectorAll('[data-fom-size]').forEach(function (button) {
      button.addEventListener('click', function () {
        selectedSize = button.dataset.fomSize;
        resolveSelection(true);
      });
    });

    root.querySelectorAll('[data-fom-frame]').forEach(function (button) {
      button.addEventListener('click', function () {
        selectedFrame = button.dataset.fomFrame;
        resolveSelection(true);
      });
    });

    root.querySelectorAll('[data-fom-thumb]').forEach(function (button) {
      button.addEventListener('click', function () {
        var mediaId = button.dataset.mediaId;
        root.querySelectorAll('[data-fom-thumb]').forEach(function (item) {
          var active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        root.querySelectorAll('[data-fom-panel]').forEach(function (panel) {
          panel.classList.toggle('is-active', panel.dataset.fomPanel === mediaId);
        });
      });
    });

    var imageDialog = root.querySelector('[data-fom-image-dialog]');
    root.querySelectorAll('[data-fom-fullscreen]').forEach(function (button) {
      button.addEventListener('click', function () {
        var activeImage = root.querySelector('[data-fom-panel].is-active img');
        var dialogImage = imageDialog?.querySelector('[data-fom-dialog-image]');
        if (activeImage && dialogImage) {
          dialogImage.src = activeImage.currentSrc || activeImage.src;
          dialogImage.alt = activeImage.alt || '';
        }
        imageDialog?.showModal();
      });
    });
    root.querySelector('[data-fom-image-close]')?.addEventListener('click', function () { imageDialog?.close(); });
    imageDialog?.addEventListener('click', function (event) { if (event.target === imageDialog) imageDialog.close(); });

    var enquiryDialog = root.querySelector('[data-fom-enquiry-dialog]');
    root.querySelectorAll('[data-fom-enquire]').forEach(function (button) {
      button.addEventListener('click', function () { enquiryDialog?.showModal(); });
    });
    root.querySelector('[data-fom-enquiry-close]')?.addEventListener('click', function () { enquiryDialog?.close(); });
    enquiryDialog?.addEventListener('click', function (event) { if (event.target === enquiryDialog) enquiryDialog.close(); });

    root.querySelector('[data-fom-mobile-acquire]')?.addEventListener('click', function () {
      acquire?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { acquire?.focus(); }, 450);
    });

    window.addEventListener('popstate', function () {
      var id = new URL(window.location.href).searchParams.get('variant');
      var record = records.find(function (item) { return item.dataset.id === id; });
      if (record) {
        selectedSize = record.dataset.size;
        selectedFrame = record.dataset.frame;
        resolveSelection(false);
      }
    });

    resolveSelection(false);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dag-frames-of-motion-premium"]) return;
  try {
    
if (!customElements.get('dag-fom-premium')) {
  customElements.define('dag-fom-premium', class extends HTMLElement {});
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-fom-premium]').forEach(function (root) {
    if (root.dataset.fompBound === 'true') return;
    root.dataset.fompBound = 'true';

    var records = Array.from(root.querySelectorAll('[data-fomp-variant]'));
    var variantInput = root.querySelector('[data-fomp-variant-input]');
    var acquire = root.querySelector('[data-fomp-acquire]');
    var priceNode = root.querySelector('[data-fomp-price]');
    var enquiryPresentation = root.querySelector('[data-fomp-enquiry-presentation]');
    var hero = root.querySelector('.fomp-hero-image');
    var selectedSizeButton = root.querySelector('[data-fomp-size].is-selected');
    var selectedFrameButton = root.querySelector('[data-fomp-frame].is-selected');
    var selectedSize = selectedSizeButton ? selectedSizeButton.dataset.fompSize : (records[0] ? records[0].dataset.size : '');
    var selectedFrame = selectedFrameButton ? selectedFrameButton.dataset.fompFrame : (records[0] ? records[0].dataset.frame : '');

    function frameKey(value) {
      return (value || '').toLowerCase().replace(/\s+/g, '-');
    }

    function findVariant(size, frame) {
      return records.find(function (item) {
        return item.dataset.size === size && item.dataset.frame === frame && item.dataset.available === 'true';
      }) || records.find(function (item) {
        return item.dataset.size === size && item.dataset.frame === frame;
      }) || null;
    }

    function prettyFrame(frame) {
      var key = frameKey(frame);
      var button = root.querySelector('[data-fomp-frame][data-frame-key="' + key + '"] .fomp-frame__text strong');
      return button ? button.textContent.trim() : frame;
    }

    function updateMediaForFrame() {
      var key = frameKey(selectedFrame);
      var match = root.querySelector('[data-fomp-thumb][data-media-finish="' + key + '"]');
      if (!match) match = root.querySelector('[data-fomp-thumb][data-media-finish="framed"]');
      if (match) selectThumb(match);
    }

    function selectThumb(button) {
      if (!button || !hero) return;
      hero.src = button.dataset.mediaSrc;
      hero.srcset = '';
      hero.alt = button.dataset.mediaAlt || '';
      root.querySelectorAll('[data-fomp-thumb]').forEach(function (item) {
        var active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
    }

    function resolveSelection(updateUrl, moveMedia) {
      var record = findVariant(selectedSize, selectedFrame);
      if (!record || record.dataset.available !== 'true') {
        var fallback = records.find(function (item) {
          return item.dataset.size === selectedSize && item.dataset.available === 'true';
        }) || records.find(function (item) {
          return item.dataset.available === 'true';
        }) || records[0];
        if (fallback) {
          record = fallback;
          selectedSize = fallback.dataset.size;
          selectedFrame = fallback.dataset.frame;
        }
      }
      if (!record) return;

      if (variantInput) variantInput.value = record.dataset.id;
      if (priceNode) priceNode.textContent = record.dataset.price;
      if (enquiryPresentation) enquiryPresentation.value = record.dataset.title;

      root.querySelectorAll('[data-fomp-size]').forEach(function (button) {
        var active = button.dataset.fompSize === selectedSize;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
        var matching = findVariant(button.dataset.fompSize, selectedFrame) || records.find(function (item) {
          return item.dataset.size === button.dataset.fompSize;
        });
        var node = button.querySelector('[data-fomp-size-price]');
        if (node && matching) node.textContent = matching.dataset.priceShort;
      });

      root.querySelectorAll('[data-fomp-frame]').forEach(function (button) {
        var active = button.dataset.fompFrame === selectedFrame;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
        var matching = findVariant(selectedSize, button.dataset.fompFrame);
        var node = button.querySelector('[data-fomp-frame-price]');
        if (node && matching) node.textContent = matching.dataset.priceShort;
      });

      if (acquire) {
        var available = record.dataset.available === 'true';
        acquire.disabled = !available;
        var label = acquire.querySelector('span');
        var word = acquire.dataset.acquireWord || 'Acquire';
        if (label) label.innerHTML = available ? word + ' — <strong>' + record.dataset.price + '</strong>' : 'Unavailable';
      }

      if (moveMedia) updateMediaForFrame();

      if (updateUrl) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', record.dataset.id);
        window.history.replaceState(window.history.state, '', url);
      }
    }

    root.querySelectorAll('[data-fomp-size]').forEach(function (button) {
      button.addEventListener('click', function () {
        selectedSize = button.dataset.fompSize;
        resolveSelection(true, false);
      });
    });

    root.querySelectorAll('[data-fomp-frame]').forEach(function (button) {
      button.addEventListener('click', function () {
        selectedFrame = button.dataset.fompFrame;
        resolveSelection(true, true);
      });
    });

    root.querySelectorAll('[data-fomp-thumb]').forEach(function (button) {
      button.addEventListener('click', function () {
        selectThumb(button);
      });
    });

    var imageDialog = root.querySelector('[data-fomp-image-dialog]');
    root.querySelectorAll('[data-fomp-fullscreen]').forEach(function (button) {
      button.addEventListener('click', function () {
        var dialogImage = imageDialog ? imageDialog.querySelector('[data-fomp-dialog-image]') : null;
        if (dialogImage && hero) {
          dialogImage.src = hero.currentSrc || hero.src;
          dialogImage.alt = hero.alt || '';
        }
        if (imageDialog && imageDialog.showModal) imageDialog.showModal();
      });
    });
    var imageClose = root.querySelector('[data-fomp-image-close]');
    if (imageClose) imageClose.addEventListener('click', function () { imageDialog.close(); });
    if (imageDialog) imageDialog.addEventListener('click', function (event) {
      if (event.target === imageDialog) imageDialog.close();
    });

    var enquiryDialog = root.querySelector('[data-fomp-enquiry-dialog]');
    root.querySelectorAll('[data-fomp-enquire]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (enquiryDialog && enquiryDialog.showModal) enquiryDialog.showModal();
      });
    });
    var enquiryClose = root.querySelector('[data-fomp-enquiry-close]');
    if (enquiryClose) enquiryClose.addEventListener('click', function () { enquiryDialog.close(); });
    if (enquiryDialog) enquiryDialog.addEventListener('click', function (event) {
      if (event.target === enquiryDialog) enquiryDialog.close();
    });

    window.addEventListener('popstate', function () {
      var id = new URL(window.location.href).searchParams.get('variant');
      var record = records.find(function (item) { return item.dataset.id === id; });
      if (record) {
        selectedSize = record.dataset.size;
        selectedFrame = record.dataset.frame;
        resolveSelection(false, false);
      }
    });

    resolveSelection(false, false);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dag-frames-of-motion-system"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-dag-system]').forEach(function (root) {
    if (root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';
    var records = Array.from(root.querySelectorAll('[data-dag-variant]'));
    if (!records.length) return;
    var input = root.querySelector('[data-dag-variant-input]');
    var acquire = root.querySelector('[data-dag-acquire]');
    var priceNode = root.querySelector('[data-dag-price]');
    var mobilePrice = root.querySelector('[data-dag-mobile-price]');
    var enquiryPresentation = root.querySelector('[data-dag-enquiry-presentation]');
    var selectedSizeNode = root.querySelector('[data-dag-selected-size]');
    var selectedFrameNode = root.querySelector('[data-dag-selected-frame]');
    var selectedSize = root.querySelector('[data-dag-size].is-selected')?.dataset.dagSize || records[0].dataset.size;
    var selectedFrame = root.querySelector('[data-dag-frame].is-selected')?.dataset.dagFrame || records[0].dataset.frame;

    function emit(action, value) {
      var detail = { action: action, value: value || '', product: window.location.pathname };
      window.dispatchEvent(new CustomEvent('dag:product_interaction', { detail: detail }));
      if (window.dataLayer) window.dataLayer.push({ event: 'dag_product_interaction', ...detail });
    }

    function findVariant(size, frame) {
      return records.find(function (item) { return item.dataset.size === size && item.dataset.frame === frame && item.dataset.available === 'true'; })
        || records.find(function (item) { return item.dataset.size === size && item.dataset.frame === frame; })
        || null;
    }

    function selectMediaForVariant() {
      var sizeNeedle = (selectedSize || '').toLowerCase().replace(/\s+/g, '');
      var frameNeedle = (selectedFrame || '').toLowerCase();
      var thumbs = Array.from(root.querySelectorAll('[data-dag-thumb]'));
      var match = thumbs.find(function (button) {
        var alt = (button.dataset.mediaAlt || '').toLowerCase().replace(/\s+/g, '');
        return alt.includes(sizeNeedle) && alt.includes(frameNeedle.replace(/\s+/g, ''));
      });
      if (!match) match = thumbs.find(function (button) { return (button.dataset.mediaAlt || '').toLowerCase().includes(frameNeedle); });
      if (match) selectThumb(match);
    }

    function selectThumb(button) {
      var id = button.dataset.mediaId;
      root.querySelectorAll('[data-dag-thumb]').forEach(function (item) {
        var active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      root.querySelectorAll('[data-dag-panel]').forEach(function (panel) { panel.classList.toggle('is-active', panel.dataset.dagPanel === id); });
    }

    function resolve(updateUrl, updateMedia) {
      var record = findVariant(selectedSize, selectedFrame);
      if (!record || record.dataset.available !== 'true') {
        var fallback = records.find(function (item) { return item.dataset.size === selectedSize && item.dataset.available === 'true'; })
          || records.find(function (item) { return item.dataset.available === 'true'; })
          || records[0];
        if (fallback) {
          record = fallback;
          selectedSize = fallback.dataset.size;
          selectedFrame = fallback.dataset.frame;
        }
      }
      if (!record) return;
      input.value = record.dataset.id;
      if (priceNode) priceNode.textContent = record.dataset.price;
      if (mobilePrice) mobilePrice.textContent = record.dataset.price;
      if (enquiryPresentation) enquiryPresentation.value = record.dataset.title;
      if (selectedSizeNode) selectedSizeNode.textContent = record.dataset.sizeDisplay || record.dataset.size;
      if (selectedFrameNode) {
        var frameButton = root.querySelector('[data-dag-frame="' + CSS.escape(record.dataset.frame) + '"]');
        selectedFrameNode.textContent = frameButton?.dataset.dagFrameDisplay || record.dataset.frame.replace(/ Frame$/, '');
      }

      root.querySelectorAll('[data-dag-size]').forEach(function (button) {
        var matching = findVariant(button.dataset.dagSize, selectedFrame);
        var active = button.dataset.dagSize === selectedSize;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
        button.disabled = !matching || matching.dataset.available !== 'true';
        var price = button.querySelector('[data-dag-size-price]');
        if (price && matching) price.textContent = matching.dataset.priceShort;
      });
      root.querySelectorAll('[data-dag-frame]').forEach(function (button) {
        var matching = findVariant(selectedSize, button.dataset.dagFrame);
        var active = button.dataset.dagFrame === selectedFrame;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
        button.disabled = !matching || matching.dataset.available !== 'true';
      });
      if (acquire) {
        var available = record.dataset.available === 'true';
        acquire.disabled = !available;
        var label = acquire.querySelector('span');
        if (label) label.innerHTML = available ? acquire.dataset.label + ' — <strong>' + record.dataset.price + '</strong>' : 'Unavailable';
      }
      if (updateMedia) selectMediaForVariant();
      if (updateUrl) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', record.dataset.id);
        window.history.replaceState(window.history.state, '', url);
      }
    }

    root.querySelectorAll('[data-dag-size]').forEach(function (button) {
      button.addEventListener('click', function () { selectedSize = button.dataset.dagSize; resolve(true, true); emit('size_select', selectedSize); });
    });
    root.querySelectorAll('[data-dag-frame]').forEach(function (button) {
      button.addEventListener('click', function () { selectedFrame = button.dataset.dagFrame; resolve(true, true); emit('frame_select', selectedFrame); });
    });
    root.querySelectorAll('[data-dag-thumb]').forEach(function (button) { button.addEventListener('click', function () { selectThumb(button); emit('media_select', button.dataset.mediaAlt); }); });
    root.querySelectorAll('[popovertarget^="DagSizeGuide-"]').forEach(function (button) { button.addEventListener('click', function () { emit('size_guide', 'open'); }); });
    root.querySelectorAll('.dag-premium-badges button').forEach(function (button) { button.addEventListener('click', function () { emit('badge_explain', button.textContent.trim()); }); });

    var enquiryDialog = root.querySelector('[data-dag-enquiry-dialog]');
    root.querySelectorAll('[data-dag-enquire]').forEach(function (button) { button.addEventListener('click', function () { emit('ask_gallery', selectedSize + ' / ' + selectedFrame); enquiryDialog?.showModal(); }); });
    root.querySelector('[data-dag-enquiry-close]')?.addEventListener('click', function () { enquiryDialog?.close(); });
    enquiryDialog?.addEventListener('click', function (event) { if (event.target === enquiryDialog) enquiryDialog.close(); });

    var imageDialog = root.querySelector('[data-dag-image-dialog]');
    root.querySelector('[data-dag-fullscreen]')?.addEventListener('click', function () {
      var activeImage = root.querySelector('[data-dag-panel].is-active img');
      var dialogImage = imageDialog?.querySelector('[data-dag-dialog-image]');
      if (activeImage && dialogImage) { dialogImage.src = activeImage.currentSrc || activeImage.src; dialogImage.alt = activeImage.alt || ''; }
      imageDialog?.showModal();
    });
    root.querySelector('[data-dag-image-close]')?.addEventListener('click', function () { imageDialog?.close(); });
    imageDialog?.addEventListener('click', function (event) { if (event.target === imageDialog) imageDialog.close(); });

    acquire?.addEventListener('click', function () { emit('acquire', selectedSize + ' / ' + selectedFrame); });
    root.querySelectorAll('[data-dag-related-work]').forEach(function (link) { link.addEventListener('click', function () { emit('related_work', link.href); }); });
    root.querySelector('[data-dag-mobile-acquire]')?.addEventListener('click', function () { acquire?.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { acquire?.focus(); }, 420); });

    resolve(false, false);
  });
});

  } catch(e) { console.error(e); }
})();
})();
